export interface FeedbackReason {
  id: string;
  label: string;
  description?: string;
}

export const LOW_RATING_FEEDBACK_REASONS: FeedbackReason[] = [
  {
    id: "not-relevant",
    label: "Not relevant to my goals",
  },
  {
    id: "not-helpful",
    label: "Not helpful or actionable",
  },
  {
    id: "poor-quality",
    label: "Poor video/audio quality",
  },
  {
    id: "too-confusing",
    label: "Too confusing",
  },
  {
    id: "not-interesting",
    label: "Not interesting enough",
  },
  {
    id: "outdated",
    label: "Outdated information",
  },
  {
    id: "technical-issues",
    label: "Technical problems",
  },
  {
    id: "other",
    label: "Other reason",
  },
];

export const FEEDBACK_CATEGORIES = {
  CONTENT: "Content Quality",
  RELEVANCE: "Relevance",
  TECHNICAL: "Technical Issues",
  ORGANIZATION: "Organization & Structure",
} as const;

// Categorized reasons for better organization in UI if needed
export const CATEGORIZED_FEEDBACK_REASONS = {
  [FEEDBACK_CATEGORIES.CONTENT]: [
    "content-quality",
    "outdated-information",
    "poor-speaker-quality",
    "no-actionable-advice",
  ],
  [FEEDBACK_CATEGORIES.RELEVANCE]: [
    "irrelevant-content",
    "too-basic",
    "too-advanced",
    "missing-key-topics",
    "lack-of-diversity",
  ],
  [FEEDBACK_CATEGORIES.TECHNICAL]: ["technical-issues", "length-issues"],
  [FEEDBACK_CATEGORIES.ORGANIZATION]: ["poor-organization"],
} as const;
